<template>
  <v-layout column>
    <v-flex xs12>
      <h1>Пользователи</h1>
    </v-flex>
    <v-flex xs12>
      <v-card class="elevation-3 pa-2">
        <v-btn color="primary" @click.stop="addUser">
          <v-icon>{{ icons.plus }}</v-icon
          >&nbsp;Добавить пользователя
        </v-btn>
      </v-card>
    </v-flex>
    <v-flex xs12 class="my-2">
      <Users :users="childUsers" v-on:edit-user="onEditUser" />
    </v-flex>
    <v-dialog persistent v-model="dialogUser" max-width="500px">
      <User
        :user="this.user"
        v-on:cancel-user="onCancelUser"
        v-on:save-user="onSaveUser"
      />
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

import Users from "@/components/Users/Users";
import User from "@/components/Users/User";

export default {
  components: {
    Users,
    User,
  },
  computed: {
    ...mapState("users", {
      childUsers: "childUsers",
    }),
  },
  methods: {
    ...mapActions({
      getUser: "users/GET_USER",
      getChildUsers: "users/GET_CHILD_USERS",
    }),
    addUser: function () {
      this.user = {};
      this.dialogUser = true;
    },
    onCancelUser: function () {
      this.dialogUser = false;
    },
    onSaveUser: function () {
      this.dialogUser = false;
    },
    onEditUser: function (user) {
      this.user = user;
      this.dialogUser = true;
    },
  },
  data: () => ({
    dialogUser: false,
    user: {},
    icons: {
      plus: Icon.plus,
    },
  }),
  mounted: async function () {
    await this.getUser();
    await this.getChildUsers();
  },
};
</script>
